import { render, staticRenderFns } from "./membershipDetails.vue?vue&type=template&id=0353bf04&scoped=true"
import script from "./membershipDetails.vue?vue&type=script&lang=js"
export * from "./membershipDetails.vue?vue&type=script&lang=js"
import style0 from "./membershipDetails.vue?vue&type=style&index=0&id=0353bf04&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0353bf04",
  null
  
)

export default component.exports